import React from 'react';
import { IconProps } from '.';

const SvgColoredFaceBad = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#FCB03F' d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z' />
      <path
        fill='#664500'
        d='M16.574 16.815c-.027-.11-.714-2.676-4.574-2.676s-4.547 2.567-4.574 2.676a.305.305 0 0 0 .145.338c.119.068.268.048.366-.046.012-.012 1.195-1.135 4.063-1.135 2.869 0 4.052 1.123 4.063 1.134a.307.307 0 0 0 .365.05.306.306 0 0 0 .146-.341ZM8.333 11.389c.844 0 1.528-.958 1.528-2.139 0-1.181-.684-2.139-1.528-2.139-.843 0-1.527.958-1.527 2.139 0 1.181.684 2.139 1.527 2.139ZM15.667 11.389c.844 0 1.528-.958 1.528-2.139 0-1.181-.684-2.139-1.528-2.139s-1.528.958-1.528 2.139c0 1.181.684 2.139 1.528 2.139Z'
      />
    </svg>
  );
};

export default SvgColoredFaceBad;
